<template>
  <div class="global-confirm-modal">
    <transition name="fade">
      <div class="modal-container custom-z-index" v-if="show">
        <transition name="slide-down">
          <div class="msg-modal custom-z-index" v-if="show">
            <div class="msg-modal-content">
              <h3 v-if="title" class="modal-title fs-20px fw-semi-bold text-center">{{ title }}</h3>
              <p class="modal-message fs-16px" :class="[ !messageClass && 'text-center', messageClass ]" v-html="message"></p>
              <b-form-checkbox
                v-if="extraComponent === 'checkbox'"
                v-model="checkedStatus"
              >
                <span>{{ extraState.label }}</span>
              </b-form-checkbox>
              <div class="btn-panel">
                <b-button variant="primary" @click="confirmModalConfirm">{{ confirmText }}</b-button>
                <b-button variant="link" @click="confirmModalCancel">{{ cancelText }}</b-button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  name: 'GlobalConfirmModal',
  data() {
    return {
    };
  },
  components: {
  },
  props: {},
  beforeDestroy() {},
  async mounted() {},
  computed: {
    ...mapState("confirm", ["show", "title", "message", "messageClass", "confirmText", "cancelText", "extraComponent", "extraState"]),

    checkedStatus: {
      get() {
        // 從 Vuex 讀取當前狀態
        return this.extraState ? this.extraState.checked : false;
      },
      set(value) {
        // 當 checkbox 變更時，觸發 action 更新 Vuex
        this.updateExtraState({
          ...this.extraState,
          checked: value
        });
      }
    },
  },
  watch: {
  },
  methods: {
    ...mapActions('confirm', ['confirmModalConfirm', 'confirmModalCancel', 'updateExtraState'])
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/main";
.global-confirm-modal {
  .modal-container {
    position: fixed;
    bottom: 0;
    left: 0;
    background: $color-bk-tp-60;
    width: 100%;
    height: 100%;
  }
}

.msg-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  background: $color-white;
  width: 22rem;
  height: fit-content;
  border-radius: .75rem;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  transform: translate(-50%, -50%);
}

.msg-modal-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.modal-title {
  margin-bottom: 0;
}

.modal-message {
  color: $color-text-secondary;
  padding: .625rem;
  margin-bottom: 0;
}

.btn-panel {
  display: flex;
  flex-direction: column;
  gap: .75rem;
  .btn.btn-link {
    color: $color-primary;
    &:hover {
      background: $color-border;
      text-decoration: none;
    }
  }
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  padding: .5rem;
}

/* === 動畫：從底下冒出／滑回下方消失 === */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all .5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-down-enter {
  opacity: 0;
  transform: translate(-50%, -75%);
}

.slide-down-enter-to {
  opacity: 1;
  transform: translate(-50%, -50%);
}

.slide-down-leave {
  opacity: 1;
  transform: translate(-50%, -50%);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translate(-50%, -75%);
}
</style>
